export default __webpack_public_path__ + "static/assigning-an-override-dark-mode-79fac18278aba0c7c04b88e3bad9e2df.mp4";